function Hgvsp() {
  return (
    <div>
      <li className="bullet-item">Protein reference sequence to describe variants</li>
    </div>
  );
}

export default Hgvsp;
